<div class="container-fluid d-flex p-0">
    <app-side-bar></app-side-bar>
    <div class="container-fluid">
        <div class="container-fluid my-3">
            <div class="top-card">
                <div class="row w-100 mx-auto d-flex  ">
                    <div class="col-sm-12 col-md-12 col-lg-9 pl-4">
                        <!-- <img class="logo-top" src="../../assets/images/logo-M (1).png"> -->
                        <span class="">Portfolio Management Suite</span>
                    </div>
                </div>
            </div>
        </div>
        <p style="font-weight: bold;">Total Count :- {{total_count}}</p>
        <div class="card" style="margin: 10px;border-radius: 10px;">
            <div class="">
                <div class="row">
                    <!-- <div class="col-2 col-md-2 col-sm-12" style="margin: 10px;">
                        <p class="my-auto ml-3" style="font-size: 20px;font-weight: 600;">Enter The Molecule</p>
                    </div>
                    <div class="col-5 col-md-5 col-sm-12" style="margin: 10px;">
                        <i class="fa fa-search icon" style="margin-right: 10px;"></i>
                        <input class="w-75" placeholder="Enter the Molecule Name" [(ngModel)]="searchValue"
                            (keydown.enter)="searchMolecule()" autofocus>
                    </div>
                    <div class="col-1 col-md-1 col-sm-12" style="margin: 10px;">
                        <button type="button" class="btn btn-light" (click)="searchMolecule()">Submit</button>
                    </div> -->
                    <div class="col-2 col-md-2 col-sm-12" style="margin: 10px;">
                        <p-dropdown [options]="submolecules" [(ngModel)]="selectedSubMolecule" autoWidth="false"
                            [style]="{'width':'90%','font-size':'12px'}" optionLabel="name" placeholder="Select Status"
                            (click)="searchMolecule()">
                        </p-dropdown>
                    </div>
                    <div class="col-2 col-md-2 col-sm-12" style="margin: 10px;">
                        <p-dropdown [options]="ndamolecules" [(ngModel)]="selectedNDAMolecule" autoWidth="false"
                            [style]="{'width':'90%','font-size':'12px'}" optionLabel="name" placeholder="Select Field"
                            (click)="searchMolecule1()">
                        </p-dropdown>
                    </div>
                    <div class="col-2 col-md-2 col-sm-12" style="margin: 10px;">
                        <p-dropdown [options]="fieldmolecules" [(ngModel)]="selectedFieldMolecule" autoWidth="false"
                            [style]="{'width':'90%','font-size':'12px'}" optionLabel="name"
                            placeholder="Select Brand Name" (click)="searchMolecule2()">
                        </p-dropdown>
                    </div>
                    <div class="col-1 col-md-1 col-sm-12" style="margin: 10px;">
                        <button type="button" class="btn btn-light" (click)="clearFilter()">Clear</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid">
            <div class="tab-execsum">
                <div>
                    <p-accordion expandIcon="pi pi-chevron-circle-down" [multiple]="true"
                        collapseIcon="pi pi-chevron-circle-up">
                        <p-accordionTab header="PRODUCT DETAILS" [selected]="true">
                            <table class="table table-bordered" id="excel-table">
                                <div class="table-responsive">
                                    <tbody>
                                        <tr>
                                            <ng-container *ngFor="let headers of commandata | keyvalue"
                                                id="Tableproduct">
                                        <tr>
                                            <td>
                                                <p>{{ headers.key }}</p>
                                            </td>
                                            <td>
                                                <p>{{ headers.value }}</p>
                                            </td>
                                        </tr>
                                        </ng-container>
                                    </tbody>
                                </div>
                            </table>
                        </p-accordionTab>
                    </p-accordion>
                </div>
            </div>
        </div>
        <div style="margin-top: 3%;">
            <table *ngIf="selectedMolecule == 'Exclusivity details'" class="table table-bordered" id="excel-table"
                style="display: inline-block;margin-left: 20px">
                <div class="table-responsive">
                    <thead>
                        <tr>
                            <td colspan="12" style="text-align: center;">{{tableheader}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="text-align: center;">Old Data</td>
                            <!-- <td *ngIf="button">Approved/Reject</td> -->
                        </tr>
                        <tr>
                            <td>Exclusivity Code</td>
                            <td>Exclusivity Expiration</td>
                            <td>Strength</td>
                            <!-- <td *ngIf="button"></td> -->
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container>
                            <tr *ngFor="let oldRow of oldexeclusivetyarray; let oldIndex = index;">
                                <ng-container>
                                    <td *ngFor="let volume of oldRow;let rowindex = index;">
                                        <p *ngIf="oldRow !==''">
                                            {{ volume }}
                                        </p>
                                        <p *ngIf=" oldRow===''"></p>
                                    </td>
                                </ng-container>
                                <!-- <td *ngIf=" oldbutton">
                                        <div style="display: flex; gap: 10px;">
                                            <button (click)="editbtn()" class="btn-success" style="padding: 5px">
                                                Edit
                                            </button>
                                            <button class="btn-success" style="padding: 5px"
                                                (click)="Approved(specifiecdata, (showedit ? 'old_data' : ''), oldIndex)">
                                                Approved
                                            </button>
                                            <button class="btn btn-primary" (click)="Reject()">
                                                Reject
                                            </button>
                                        </div>
                                    </td> -->
                            </tr>
                        </ng-container>
                    </tbody>
                </div>
            </table>
            <table *ngIf="selectedMolecule == 'Exclusivity details'" class="table table-bordered" id="excel-table"
                style="display: inline-block;margin-left: 20px">
                <div class="table-responsive">
                    <thead>
                        <tr>
                            <td colspan="12" style="text-align: center;">{{tableheader}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="text-align: center;">New Data</td>
                            <td *ngIf="button">Approved/Reject</td>
                        </tr>
                        <tr>
                            <td>Exclusivity Code</td>
                            <td>Exclusivity Expiration</td>
                            <td>Strength</td>
                            <td *ngIf="button"></td>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container>
                            <tr *ngFor="let row of newexeclusivetyarray;let j = index;">
                                <td *ngFor="let volume of row;let rowindex = index; let colIndex = index;">
                                    <p *ngIf="showedit == true">
                                        <input type="text" [id]="'volume' + j + 'row' + rowindex"
                                            [name]="'volume' + j + 'row' + rowindex" value={{volume}}
                                            (input)="updateNewData(rowindex, $event.target.value, 'columnName')"
                                            data-index="{{rowindex}}" />
                                    </p>
                                    <p *ngIf="showedit == false">
                                        {{volume}}
                                    </p>
                                </td>
                                <td *ngIf="button">
                                    <div style="display: flex; gap: 10px;">
                                        <button (click)="editbtn(j,row)" class="btn-success" style="padding: 5px">
                                            Edit
                                        </button>
                                        <button (click)="deleteTextBox(j, row)" class="btn-success"
                                            style="padding: 5px;">
                                            delete
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            <div>
                                <td *ngIf="button" colspan="12">
                                    <button class="btn-success" style="padding: 5px"
                                        (click)="Approved(newexeclusivetyarray, showedit ? 'new_data' : 'only_approved', newdata)">
                                        Approved
                                    </button>
                                    <button class="btn btn-primary" (click)="Reject(newexeclusivetyarray)"
                                        style="margin-left:20px;">
                                        Reject
                                    </button>
                            </div>
                        </ng-container>
                    </tbody>
                </div>
            </table>
            <table
                *ngIf="selectedMolecule == 'Indicative API price ($/kg)' || selectedMolecule == 'PDE applied 6 months*' || selectedMolecule == 'Orphan Drug Exclusivity' || selectedMolecule == 'Reference Listed Drug (RLD)' || selectedMolecule == 'Reference Standard (RS)'"
                class="table table-bordered" id="excel-table" style="display: inline-block;margin-left: 20px">
                <div class="table-responsive">
                    <thead>
                        <tr>
                            <td colspan="12" style="text-align: center;">{{tableheader}}</td>
                        </tr>
                        <tr>
                            <td colspan="3" style="text-align: center;">Old Data</td>
                            <!-- <td *ngIf="button">Approved/Reject</td> -->
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container>
                            <tr>
                                <ng-container>
                                    <td>
                                        <p>
                                            {{ indicativeSpecificOldData }}
                                        </p>
                                        <p *ngIf="oldRow ===''"></p>
                                    </td>
                                </ng-container>
                                <!-- <td *ngIf="oldbutton">
                                    <div style="display: flex; gap: 10px;">
                                        <button (click)="editbtn()" class="btn-success" style="padding: 5px">
                                            Edit
                                        </button>
                                        <button class="btn-success" style="padding: 5px"
                                            (click)="Approved(specifiecdata, (showedit ? 'old_data' : ''), oldIndex)">
                                            Approved
                                        </button>
                                        <button class="btn btn-primary" (click)="Reject()">
                                            Reject
                                        </button>
                                    </div>
                                </td> -->
                            </tr>
                        </ng-container>
                    </tbody>
                </div>
            </table>
            <table
                *ngIf="selectedMolecule == 'Indicative API price ($/kg)' || selectedMolecule == 'PDE applied 6 months*' || selectedMolecule == 'Orphan Drug Exclusivity' || selectedMolecule == 'Reference Listed Drug (RLD)' || selectedMolecule == 'Reference Standard (RS)'"
                class="table table-bordered" id="excel-table" style="display: inline-block;margin-left: 20px">
                <div class="table-responsive">
                    <thead>
                        <tr>
                            <td colspan="12" style="text-align: center;">{{tableheader}}</td>
                        </tr>
                        <tr>
                            <td style="text-align: center;">New Data</td>
                            <td *ngIf="button">Approved/Reject</td>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container>
                            <tr>
                                <td>
                                    <p *ngIf="showedit == true" style="width: max-content;">
                                        <input type="text" [id]="'volume' + 0 + 'row' + 0"
                                            [name]="'volume' + 0 + 'row' + 0" value={{indicativeSpecificNewData}}
                                            (input)="updateNewData(0, $event.target.value)" />
                                    </p>
                                    <p *ngIf="showedit == false">
                                        {{indicativeSpecificNewData}}
                                    </p>
                                </td>
                                <td *ngIf="button && indicativeSpecificNewData!=''">
                                    <div style="display: flex; gap: 10px;">
                                        <button (click)="editbtn(j,indicativeSpecificNewData)" class="btn-success"
                                            style="padding: 5px">
                                            Edit
                                        </button>
                                        <button class="btn-success" style="padding: 5px;">
                                            delete
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            <tr colspan="12" *ngIf="button">
                                <td>
                                    <button class="btn-success" style="padding: 5px"
                                        (click)="Approved(indicativeSpecificNewData,showedit ? 'new_data' : 'only_approved',newdata)">
                                        Approved
                                    </button>
                                    <button class="btn btn-primary" (click)="Reject(row)" style="margin-left:20px;">
                                        Reject
                                    </button>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </div>
            </table>
            <table *ngIf="selectedMolecule == 'Innovator / RLD Price ($/pack)'" class="table table-bordered"
                id="excel-table" style="display: inline-block;margin-left: 20px">
                <div class="table-responsive">
                    <thead>
                        <tr>
                            <td colspan="12" style="text-align: center;">{{tableheader}}</td>
                        </tr>
                        <tr>
                            <td colspan="5" style="text-align: center;">Old Data</td>
                            <!-- <td *ngIf="button">Approved/Reject</td> -->
                        </tr>
                        <tr>
                            <td>Quantity</td>
                            <td>Per unit</td>
                            <td>Price</td>
                            <td>Strengths</td>
                            <td>Roa</td>
                            <!-- <td *ngIf="button"></td> -->
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container>
                            <tr *ngFor="let oldRow of oldexeclusivetyarray; let oldIndex = index;">
                                <ng-container>
                                    <td *ngFor="let volume of oldRow;let rowindex = index;">
                                        <p *ngIf="oldRow !==''">
                                            {{ volume }}
                                        </p>
                                        <p *ngIf=" oldRow===''"></p>
                                    </td>
                                </ng-container>
                            </tr>
                        </ng-container>
                    </tbody>
                </div>
            </table>
            <table *ngIf="selectedMolecule == 'Innovator / RLD Price ($/pack)'" class="table table-bordered"
                id="excel-table" style="display: inline-block;margin-left: 20px">
                <div class="table-responsive">
                    <thead>
                        <tr>
                            <td colspan="12" style="text-align: center;">{{tableheader}}</td>
                        </tr>
                        <tr>
                            <td colspan="5" style="text-align: center;">New Data</td>
                            <td *ngIf="button">Approved/Reject</td>
                        </tr>
                        <tr>
                            <td>Quantity</td>
                            <td>Per unit</td>
                            <td>Price</td>
                            <td>Strengths</td>
                            <td>Roa</td>
                            <td *ngIf="button"></td>
                        </tr>
                    </thead>
                    <tr *ngFor="let row of newexeclusivetyarray;let j = index;">
                        <td *ngFor="let volume of row;let rowindex = index;">
                            <p *ngIf="showedit == true">
                                <input type="text" [id]="'volume' + j + 'row' + rowindex"
                                    [name]="'volume' + j + 'row' + rowindex" value={{volume}}
                                    (input)="updateNewData(rowindex, $event.target.value)" data-index="{{rowindex}}" />
                            </p>
                            <p *ngIf="showedit == false">
                                {{volume}}
                            </p>
                        </td>
                        <td *ngIf="button">
                            <div style="display: flex; gap: 10px;">
                                <button (click)="editbtn(j,row)" class="btn-success" style="padding: 5px">
                                    Edit
                                </button>
                                <button (click)="deleteTextBox(j, row)" class="btn-success" style="padding: 5px;">
                                    delete
                                </button>
                            </div>
                        </td>
                    </tr>
                    <div>
                        <td *ngIf="button" colspan="12">
                            <button class="btn-success" style="padding: 5px"
                                (click)="Approved(newexeclusivetyarray, showedit ? 'new_data' : 'only_approved', newdata)">
                                Approved
                            </button>
                            <button class="btn btn-primary" (click)="Reject(newexeclusivetyarray)"
                                style="margin-left:20px;">
                                Reject
                            </button>
                    </div>
                </div>
            </table>
            <table class="table table-bordered" id="excel-table" style="display: inline-block;margin-left: 20px"
                *ngIf="ndaNumberPresent">
                <div class="table-responsive">
                    <thead>
                        <tr>
                            <td colspan="12" style="text-align: center;">{{tableheader}}</td>
                        </tr>
                        <tr>
                            <td colspan="5" style="text-align: center;">Edited Data</td>
                            <td *ngIf="button">Approved/Reject</td>
                        </tr>
                        <tr>
                            <ng-container *ngFor="let item of volumeheader">
                                <td>{{ item }}</td>
                            </ng-container>
                            <td *ngIf="button"></td>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container>
                            <tr *ngFor="let row of editedexeclusivetyarray;let j = index;">
                                <td *ngFor="let volume of row;let rowindex = index;">
                                    <p>
                                        {{volume}}
                                    </p>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </div>
            </table>
            <table *ngIf="selectedMolecule == 'Approved ANDA filers'" class="table table-bordered" id="excel-table"
                style="display: inline-block;margin-left: 15px">
                <div class="table-responsive">
                    <thead>
                        <tr>
                            <td colspan="12" style="text-align: center;">{{tableheader}}</td>
                        </tr>
                        <tr>
                            <td colspan="12" style="text-align: center;">Old Data</td>
                            <!-- <td *ngIf="button">Approved/Reject</td> -->
                        </tr>
                        <tr>
                            <td>ANDA No</td>
                            <td>Drug Name</td>
                            <td>Active Ingredients</td>
                            <td>Strength</td>
                            <td>Dosage Form/Route</td>
                            <td>Marketing Status</td>
                            <td>Approval Date</td>
                            <td>Applicant Holder</td>
                            <!-- <td *ngIf="button"></td> -->
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container>
                            <tr *ngFor="let oldRow of oldexeclusivetyarray; let oldIndex = index;">
                                <ng-container>
                                    <td *ngFor="let volume of oldRow;let rowindex = index;">
                                        <p *ngIf="oldRow !==''">
                                            {{ volume }}
                                        </p>
                                        <p *ngIf=" oldRow===''"></p>
                                    </td>
                                </ng-container>
                                <!-- <td *ngIf=" oldbutton">
                                    <div style="display: flex; gap: 10px;">
                                        <button (click)="editbtn()" class="btn-success" style="padding: 5px">
                                            Edit
                                        </button>
                                        <button class="btn-success" style="padding: 5px"
                                            (click)="Approved(specifiecdata, (showedit ? 'old_data' : ''), oldIndex)">
                                            Approved
                                        </button>
                                        <button class="btn btn-primary" (click)="Reject()">
                                            Reject
                                        </button>
                                    </div>
                                </td> -->
                            </tr>
                        </ng-container>
                    </tbody>
                </div>
            </table>
            <table *ngIf="selectedMolecule == 'Approved ANDA filers'" class="table table-bordered" id="excel-table"
                style="display: inline-block;margin-left: 15px">
                <div class="table-responsive">
                    <thead>
                        <tr>
                            <td colspan="12" style="text-align: center;">{{tableheader}}</td>
                        </tr>
                        <tr>
                            <td colspan="8" style="text-align: center;">New Data</td>
                            <td *ngIf="button">Approved/Reject</td>
                        </tr>
                        <tr>
                            <td>ANDA No</td>
                            <td>Drug Name</td>
                            <td>Active Ingredients</td>
                            <td>Strength</td>
                            <td>Dosage Form/Route</td>
                            <td>Marketing Status</td>
                            <td>Approval Date</td>
                            <td>Applicant Holder</td>
                            <td *ngIf="button"></td>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container>
                            <tr *ngFor="let row of newexeclusivetyarray;let j = index;">
                                <td *ngFor="let volume of row;let rowindex = index;">
                                    <p *ngIf="showedit == true">
                                        <input type="text" [id]="'volume' + j + 'row' + rowindex"
                                            [name]="'volume' + j + 'row' + rowindex" value={{volume}}
                                            (input)="updateNewData(rowindex, $event.target.value)"
                                            data-index="{{rowindex}}" />
                                    </p>
                                    <p *ngIf="showedit == false">
                                        {{volume}}
                                    </p>
                                </td>
                                <td *ngIf="button">
                                    <div style="display: flex; gap: 10px;">
                                        <button (click)="editbtn(j,row)" class="btn-success" style="padding: 5px">
                                            Edit
                                        </button>
                                        <button (click)="deleteTextBox(j, row)" class="btn-success"
                                            style="padding: 5px;">
                                            delete
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            <div>
                                <td *ngIf="button" colspan="12">
                                    <button class="btn-success" style="padding: 5px"
                                        (click)="Approved(newexeclusivetyarray, showedit ? 'new_data' : 'only_approved', newdata)">
                                        Approved
                                    </button>
                                    <button class="btn btn-primary" (click)="Reject(newexeclusivetyarray)"
                                        style="margin-left:20px;">
                                        Reject
                                    </button>
                            </div>
                        </ng-container>
                    </tbody>
                </div>
            </table>
            <table *ngIf="selectedMolecule == 'Existing DMF filers'" class="table table-bordered" id="excel-table"
                style="display: inline-block;margin-left: 15px">
                <div class="table-responsive">
                    <thead>
                        <tr>
                            <td colspan="12" style="text-align: center;">{{tableheader}}</td>
                        </tr>
                        <tr>
                            <td colspan="4" style="text-align: center;">Old Data</td>
                            <!-- <td *ngIf="button">Approved/Reject</td> -->
                        </tr>
                        <tr>
                            <td>DMF#</td>
                            <td>SUBMIT DATE</td>
                            <td>SUBJECT</td>
                            <td>SUBMIT DATE</td>
                            <!-- <td *ngIf="button"></td> -->
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container>
                            <tr *ngFor="let oldRow of oldexeclusivetyarray; let oldIndex = index;">
                                <ng-container>
                                    <td *ngFor="let volume of oldRow;let rowindex = index;">
                                        <p *ngIf="oldRow !==''">
                                            {{ volume }}
                                        </p>
                                        <p *ngIf=" oldRow===''"></p>
                                    </td>
                                </ng-container>
                                <!-- <td *ngIf=" oldbutton">
                                <div style="display: flex; gap: 10px;">
                                    <button (click)="editbtn()" class="btn-success" style="padding: 5px">
                                        Edit
                                    </button>
                                    <button class="btn-success" style="padding: 5px"
                                        (click)="Approved(specifiecdata, (showedit ? 'old_data' : ''), oldIndex)">
                                        Approved
                                    </button>
                                    <button class="btn btn-primary" (click)="Reject()">
                                        Reject
                                    </button>
                                </div>
                            </td> -->
                            </tr>
                        </ng-container>
                    </tbody>
                </div>
            </table>
            <table *ngIf="selectedMolecule == 'Existing DMF filers'" class="table table-bordered" id="excel-table"
                style="display: inline-block;margin-left: 15px">
                <div class="table-responsive">
                    <thead>
                        <tr>
                            <td colspan="12" style="text-align: center;">{{tableheader}}</td>
                        </tr>
                        <tr>
                            <td colspan="4" style="text-align: center;">New Data</td>
                            <td *ngIf="button">Approved/Reject</td>
                        </tr>
                        <tr>
                            <td>DMF#</td>
                            <td>SUBMIT DATE</td>
                            <td>SUBJECT</td>
                            <td>SUBMIT DATE</td>
                            <td *ngIf="button"></td>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container>
                            <tr *ngFor="let row of newexeclusivetyarray;let j = index;">
                                <td *ngFor="let volume of row;let rowindex = index;">
                                    <p *ngIf="showedit == true">
                                        <input type="text" [id]="'volume' + j + 'row' + rowindex"
                                            [name]="'volume' + j + 'row' + rowindex" value={{volume}}
                                            (input)="updateNewData(rowindex, $event.target.value)"
                                            data-index="{{rowindex}}" />
                                    </p>
                                    <p *ngIf="showedit == false">
                                        {{volume}}
                                    </p>
                                </td>
                                <td *ngIf="button">
                                    <div style="display: flex; gap: 10px;">
                                        <button (click)="editbtn(j,row)" class="btn-success" style="padding: 5px">
                                            Edit
                                        </button>
                                        <button (click)="deleteTextBox(j, row)" class="btn-success"
                                            style="padding: 5px;">
                                            delete
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            <div>
                                <td *ngIf="button" colspan="12">
                                    <button class="btn-success" style="padding: 5px"
                                        (click)="Approved(newexeclusivetyarray, showedit ? 'new_data' : 'only_approved', newdata)">
                                        Approved
                                    </button>
                                    <button class="btn btn-primary" (click)="Reject(newexeclusivetyarray)"
                                        style="margin-left:20px;">
                                        Reject
                                    </button>
                            </div>
                        </ng-container>
                    </tbody>
                </div>
            </table>
            <table *ngIf="selectedMolecule == 'IPR details (if any)'" class="table table-bordered" id="excel-table"
                style="display: inline-block;margin-left: 15px">
                <div class="table-responsive">
                    <thead>
                        <tr>
                            <td colspan="12" style="text-align: center;">{{tableheader}}</td>
                        </tr>
                        <tr>
                            <td colspan="8" style="text-align: center;">Old Data</td>
                            <!-- <td *ngIf="button">Approved/Reject</td> -->
                        </tr>
                        <tr>
                            <td>Proceeding Filing Date</td>
                            <td>Proceeding Number</td>
                            <td>Respondent Patent Number</td>
                            <td>respondentPartyName</td>
                            <td>Petitioner Party Name</td>
                            <td>Proceeding Status Category</td>
                            <td>Proceeding Type Category</td>
                            <td>Decision Date</td>
                            <!-- <td *ngIf="button"></td> -->
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container>
                            <tr *ngFor="let oldRow of oldexeclusivetyarray; let oldIndex = index;">
                                <ng-container>
                                    <td *ngFor="let volume of oldRow;let rowindex = index;">
                                        <p *ngIf="oldRow !==''">
                                            {{ volume }}
                                        </p>
                                        <p *ngIf=" oldRow===''"></p>
                                    </td>
                                </ng-container>
                                <!-- <td *ngIf=" oldbutton">
                            <div style="display: flex; gap: 10px;">
                                <button (click)="editbtn()" class="btn-success" style="padding: 5px">
                                    Edit
                                </button>
                                <button class="btn-success" style="padding: 5px"
                                    (click)="Approved(specifiecdata, (showedit ? 'old_data' : ''), oldIndex)">
                                    Approved
                                </button>
                                <button class="btn btn-primary" (click)="Reject()">
                                    Reject
                                </button>
                            </div>
                        </td> -->
                            </tr>
                        </ng-container>
                    </tbody>
                </div>
            </table>
            <table *ngIf="selectedMolecule == 'IPR details (if any)'" class="table table-bordered" id="excel-table"
                style="display: inline-block;margin-left: 15px">
                <div class="table-responsive">
                    <thead>
                        <tr>
                            <td colspan="12" style="text-align: center;">{{tableheader}}</td>
                        </tr>
                        <tr>
                            <td colspan="6" style="text-align: center;">New Data</td>
                            <td *ngIf="button">Approved/Reject</td>
                        </tr>
                        <tr>
                            <td>proceedingFilingDate</td>
                            <td>proceedingNumber</td>
                            <td>respondentPatentNumber</td>
                            <td>petitionerPartyName</td>
                            <td>proceedingStatusCategory</td>
                            <td>petitionerCounselName</td>
                            <td *ngIf="button"></td>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container>
                            <tr *ngFor="let row of newexeclusivetyarray;let j = index;">
                                <td *ngFor="let volume of row;let rowindex = index;">
                                    <p *ngIf="showedit == true">
                                        <input type="text" [id]="'volume' + j + 'row' + rowindex"
                                            [name]="'volume' + j + 'row' + rowindex" value={{volume}}
                                            (input)="updateNewData(rowindex, $event.target.value)"
                                            data-index="{{rowindex}}" />
                                    </p>
                                    <p *ngIf="showedit == false">
                                        {{volume}}
                                    </p>
                                </td>
                                <td *ngIf="button">
                                    <div style="display: flex; gap: 10px;">
                                        <button (click)="editbtn(j,row)" class="btn-success" style="padding: 5px">
                                            Edit
                                        </button>
                                        <button (click)="deleteTextBox(j, row)" class="btn-success"
                                            style="padding: 5px;">
                                            delete
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            <div>
                                <td *ngIf="button" colspan="12">
                                    <button class="btn-success" style="padding: 5px"
                                        (click)="Approved(newexeclusivetyarray, showedit ? 'new_data' : 'only_approved', newdata)">
                                        Approved
                                    </button>
                                    <button class="btn btn-primary" (click)="Reject(newexeclusivetyarray)"
                                        style="margin-left:20px;">
                                        Reject
                                    </button>
                            </div>
                        </ng-container>
                    </tbody>
                </div>
            </table>
            <table *ngIf="selectedMolecule == 'Marketing Status'" class="table table-bordered" id="excel-table"
                style="display: inline-block;margin-left: 15px">
                <div class="table-responsive">
                    <thead>
                        <tr>
                            <td colspan="12" style="text-align: center;">{{tableheader}}</td>
                        </tr>
                        <tr>
                            <td colspan="2" style="text-align: center;">Old Data</td>
                            <!-- <td *ngIf="button">Approved/Reject</td> -->
                        </tr>
                        <tr>
                            <td>Strength</td>
                            <td>Mkt Status</td>
                            <!-- <td *ngIf="button"></td> -->
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container>
                            <tr *ngFor="let oldRow of oldexeclusivetyarray; let oldIndex = index;">
                                <ng-container>
                                    <td *ngFor="let volume of oldRow;let rowindex = index;">
                                        <p *ngIf="oldRow !==''">
                                            {{ volume }}
                                        </p>
                                        <p *ngIf=" oldRow===''"></p>
                                    </td>
                                </ng-container>
                                <!-- <td *ngIf=" oldbutton">
                        <div style="display: flex; gap: 10px;">
                            <button (click)="editbtn()" class="btn-success" style="padding: 5px">
                                Edit
                            </button>
                            <button class="btn-success" style="padding: 5px"
                                (click)="Approved(specifiecdata, (showedit ? 'old_data' : ''), oldIndex)">
                                Approved
                            </button>
                            <button class="btn btn-primary" (click)="Reject()">
                                Reject
                            </button>
                        </div>
                    </td> -->
                            </tr>
                        </ng-container>
                    </tbody>
                </div>
            </table>
            <table *ngIf="selectedMolecule == 'Marketing Status'" class="table table-bordered" id="excel-table"
                style="display: inline-block;margin-left: 15px">
                <div class="table-responsive">
                    <thead>
                        <tr>
                            <td colspan="12" style="text-align: center;">{{tableheader}}</td>
                        </tr>
                        <tr>
                            <td colspan="2" style="text-align: center;">New Data</td>
                            <td *ngIf="button">Approved/Reject</td>
                        </tr>
                        <tr>
                            <td>Strength</td>
                            <td>Marketing Status</td>
                            <td *ngIf="button"></td>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container>
                            <tr *ngFor="let row of newexeclusivetyarray;let j = index;">
                                <td *ngFor="let volume of row;let rowindex = index;">
                                    <p *ngIf="showedit == true">
                                        <input type="text" [id]="'volume' + j + 'row' + rowindex"
                                            [name]="'volume' + j + 'row' + rowindex" value={{volume}}
                                            (input)="updateNewData(rowindex, $event.target.value)"
                                            data-index="{{rowindex}}" />
                                    </p>
                                    <p *ngIf="showedit == false">
                                        {{volume}}
                                    </p>
                                </td>
                                <td *ngIf="button">
                                    <div style="display: flex; gap: 10px;">
                                        <button (click)="editbtn(j,row)" class="btn-success" style="padding: 5px">
                                            Edit
                                        </button>
                                        <button (click)="deleteTextBox(j, row)" class="btn-success"
                                            style="padding: 5px;">
                                            delete
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            <div>
                                <td *ngIf="button" colspan="12">
                                    <button class="btn-success" style="padding: 5px"
                                        (click)="Approved(newexeclusivetyarray, showedit ? 'new_data' : 'only_approved', newdata)">
                                        Approved
                                    </button>
                                    <button class="btn btn-primary" (click)="Reject(newexeclusivetyarray)"
                                        style="margin-left:20px;">
                                        Reject
                                    </button>
                            </div>
                        </ng-container>
                    </tbody>
                </div>
            </table>
            <table *ngIf="selectedMolecule == 'PTE applied (Max 5 years)'" class="table table-bordered" id="excel-table"
                style="display: inline-block;margin-left: 15px">
                <div class="table-responsive">
                    <thead>
                        <tr>
                            <td colspan="12" style="text-align: center;">{{tableheader}}</td>
                        </tr>
                        <tr>
                            <td colspan="4" style="text-align: center;">Old Data</td>
                            <!-- <td *ngIf="button">Approved/Reject</td> -->
                        </tr>
                        <tr>
                            <td>Patent No</td>
                            <td>Expiration date</td>
                            <td>Product (Applicant for PTE)</td>
                            <td>Extension Requested</td>
                            <!-- <td *ngIf="button"></td> -->
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container>
                            <tr *ngFor="let oldRow of oldexeclusivetyarray; let oldIndex = index;">
                                <ng-container>
                                    <td *ngFor="let volume of oldRow;let rowindex = index;">
                                        <p *ngIf="oldRow !==''">
                                            {{ volume }}
                                        </p>
                                        <p *ngIf=" oldRow===''"></p>
                                    </td>
                                </ng-container>
                                <!-- <td *ngIf=" oldbutton">
                        <div style="display: flex; gap: 10px;">
                            <button (click)="editbtn()" class="btn-success" style="padding: 5px">
                                Edit
                            </button>
                            <button class="btn-success" style="padding: 5px"
                                (click)="Approved(specifiecdata, (showedit ? 'old_data' : ''), oldIndex)">
                                Approved
                            </button>
                            <button class="btn btn-primary" (click)="Reject()">
                                Reject
                            </button>
                        </div>
                    </td> -->
                            </tr>
                        </ng-container>
                    </tbody>
                </div>
            </table>
            <table *ngIf="selectedMolecule == 'PTE applied (Max 5 years)'" class="table table-bordered" id="excel-table"
                style="display: inline-block;margin-left: 15px">
                <div class="table-responsive">
                    <thead>
                        <tr>
                            <td colspan="12" style="text-align: center;">{{tableheader}}</td>
                        </tr>
                        <tr>
                            <td colspan="4" style="text-align: center;">New Data</td>
                            <td *ngIf="button">Approved/Reject</td>
                        </tr>
                        <tr>
                            <td>Patent No</td>
                            <td>Tradename of Product (generic name, if applicable)</td>
                            <td>Original Expiration Date*</td>
                            <td>Period of Extension Granted</td>
                            <td *ngIf="button"></td>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container>
                            <tr *ngFor="let row of newexeclusivetyarray;let j = index;">
                                <td *ngFor="let volume of row;let rowindex = index;">
                                    <p *ngIf="showedit == true">
                                        <input type="text" [id]="'volume' + j + 'row' + rowindex"
                                            [name]="'volume' + j + 'row' + rowindex" value={{volume}}
                                            (input)="updateNewData(rowindex, $event.target.value)"
                                            data-index="{{rowindex}}" />
                                    </p>
                                    <p *ngIf="showedit == false">
                                        {{volume}}
                                    </p>
                                </td>
                                <td *ngIf="button">
                                    <div style="display: flex; gap: 10px;">
                                        <button (click)="editbtn(j,row)" class="btn-success" style="padding: 5px">
                                            Edit
                                        </button>
                                        <button (click)="deleteTextBox(j, row)" class="btn-success"
                                            style="padding: 5px;">
                                            delete
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            <div>
                                <td *ngIf="button" colspan="12">
                                    <button class="btn-success" style="padding: 5px"
                                        (click)="Approved(newexeclusivetyarray, showedit ? 'new_data' : 'only_approved', newdata)">
                                        Approved
                                    </button>
                                    <button class="btn btn-primary" (click)="Reject(newexeclusivetyarray)"
                                        style="margin-left:20px;">
                                        Reject
                                    </button>
                            </div>
                        </ng-container>
                    </tbody>
                </div>
            </table>
        </div>